(function($){

  var emailSignUp = {
    settings: {},

    $modal: null,

    bindFormulate: function($form, successCallback) {
      $form = $form || $('#email-signup');

      $form.formulate({
        require: 'FirstName, LastName, Email{email}',
        errorClass: 'form__field--error',
        showOnSubmit: '[data-js-hook="email-signup-confirm"]',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        fireOnSubmit: function() {
          $(':submit', $form).addClass('btn-submitting');
          $form.find('.form__loading').fadeIn(200);
        },
        fireOnSuccess: function() {
          Jonahlytics.event.formSubmit('email-signup');
          $form.find('.form__loading').fadeOut(200);

          if (successCallback) {
            successCallback();
          }
          $(':submit', $form).removeClass('btn-submitting');
        },
        fireOnError: function(){
          $form.find('.form__loading').fadeOut(200);
          $form.find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
          $(':submit', $form).removeClass('btn-submitting');
        }
      });
    },

    modal: function() {
      var self = this;

      if ($('[href*="'+this.settings.modal_url_target+'"]').length && this.settings.modal_enabled && !window.location.pathname.match(/contact\/email-sign-up/)) {
        $('[href*="'+this.settings.modal_url_target+'"]').click(function(e){
          var $trigger = $(this);
          e.preventDefault();

          if (!self.$modal) {
            $.get($(this).attr('href'), function(responseHtml){
              self.$modal = $('<div class="form-modal">\
                <div class="form-modal__content">\
                  <a data-js-hook="close-form-modal" class="form-modal__close" href="">&times;</a>\
                  <div class="form-modal__body palette-' + jcms.base_palette.slug + '">'+responseHtml+'</div>\
                </div>\
              </div>').hide();

              $('body').append(self.$modal);
              self.$modal.fadeIn(200);

              self.$modal.find('[data-js-hook="close-form-modal"]').click(function(e){
                e.preventDefault();
                self.$modal.fadeOut(200);
              });

              self.$modal.click(function(e){
                if ($(e.target).parent().is('body')) {
                  self.$modal.fadeOut(200);
                }
              });

              $(document).keyup(function(e) {
                if (e.key === "Escape") {
                  self.$modal.fadeOut(200);
                }
              });

              self.bindFormulate(self.$modal.find('form'), function(){
                var start = 1;
                var end = self.settings.modal_timeout / 1000;
                var display = end;

                var countdown = setInterval(function(){
                  if (start <= end) {
                    -- display;
                    $('#email-sign-up-confirm-countdown-number').text(display);
                    ++start;
                  } else {
                    clearInterval(countdown);
                    $('#email-sign-up-confirm-countdown').hide();
                  }
                }, 1000);

                setTimeout(function(){
                  self.$modal.fadeOut(200);
                }, self.settings.modal_timeout);
              });

              self.$modal.find('[data-infield-label]').each(function() {
                var self = $(this);
                var target = $(this).attr('for');
                var input = $('#'+target);
                input.on('focus', function(){
                  if (!$(this).val()) {
                    self.addClass('focus');
                  }
                });
                input.on('keyup input', function() {
                  if ($(this).val()) {
                    self.removeClass('focus');
                    self.addClass('active');
                  }
                  else {
                    self.removeClass('active');
                    self.addClass('focus');
                  }
                });
                input.on('blur', function() {
                  if (!$(this).val()) {
                    self.removeClass('focus');
                  }
                });
              });
            });
          } else {
            self.$modal.fadeIn(200);
          }
        });

      }
    },

    init: function() {
      if (typeof jcms.email_signup_settings != 'undefined') {
        this.settings = jcms.email_signup_settings;
        this.bindFormulate();

        if (this.settings.modal_enabled) {
          this.modal();
        }
      }
    }
  };

  $(function(){
    emailSignUp.init();
  });

})(jQuery);
